import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ApiCall, FindTranslatedKey, } from '../CommonComponents/CustomHooks';
import { FormButton, InputBox } from '../CommonComponents/InputBox';
import { FaShippingFast } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";
import { NotificationSound } from '../CommonComponents/CommonNotification';
const AwbQuery = () => {
    const inputrefs = useRef([])
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const [anotherTableData, setAnotherTableData] = useState({})
    const searchParams = new URLSearchParams(location.search);
    const headerTrackingNumber = searchParams.get('awbNumber');

    const [formData, setFormData] = useState({
        awbNumber: ""
    });

    const getAnotherTrackData = async (value) => {
        let GetData = {
            AwbNo: value ? value : formData.awbNumber,
        }
        setLoading(true)
        let data = await ApiCall('/api/Operation/AwbQueryReport', GetData)
        if (data.status === 'ERROR' || data.status === 'EXPIRED') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
        setAnotherTableData(data)
        setLoading(false)
    }

    const handleClear = () => {
        setFormData({
            awbNumber: "",
        });
        setAnotherTableData({})
        inputrefs.current['txtAwbNumber'].focus();
    };

    const handleSubmit = () => {
        getAnotherTrackData()
    }

    useEffect(() => {
        setFormData({ ...formData, awbNumber: headerTrackingNumber })
        if (headerTrackingNumber) getAnotherTrackData(headerTrackingNumber)
    }, [headerTrackingNumber])


    useEffect(() => {
        inputrefs.current['txtAwbNumber'].focus();
        document.title = 'Awb Query'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Awb Query')} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className="row">
                            <InputBox
                                label='Awb Number/ReferenceNo'
                                inputrefs={inputrefs}
                                id='txtAwbNumber'
                                PlaceHolderText="Awb Number/ReferenceNo"
                                value={formData.awbNumber}
                                maxLength='25'
                                onChange={(e) => {
                                   // let { value } = e.target.value
                                   // const aphanum = value.replace(/[^a-zA-Z0-9]/g, '')
                                    setFormData({ ...formData, awbNumber: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus();
                                    }
                                }}
                            />
                            <div className="col-md-4 mt-3">
                                <FormButton
                                    id={"btnSub"}
                                    Search={true}
                                    handleSubmit={handleSubmit}
                                    save={false}
                                    Export={false}
                                    handleClear={handleClear}
                                    inputrefs={inputrefs}

                                />
                            </div>
                        </div>


                    </div>

                </div>
            </div>


            {anotherTableData?.shipmentDetail &&
                <div className='main-card card border-0 mb-2' style={{ borderTop: "2px solid #f18282" }}>
                    <div className='d-flex justify-content-between'>
                        <h5 className='m-1 p-2 awbgradient' > {FindTranslatedKey('Shipment Detail')} <FaShippingFast className='text-success' /></h5>
                        <h5 className='m-1 p-2 awbgradient' > {FindTranslatedKey('Customer Ref No:')} {anotherTableData.shipmentDetail.customerRefNo }</h5>

                    </div>
                  
                    {/* Filter and Advance Filter Icon and paging*/}
                    <div className='card-header mb-1'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-md-4'>

                            </div>
                            <div className='card-body'>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mb-0">
                                        <tbody style={{ fontSize: '13px', padding: '1px' }}>
                                            <tr >
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hReferenceNo)}  </td>
                                                <td >{anotherTableData.shipmentDetail.referenceNo} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hAwbNo)}  </td>
                                                <td colspan='3' >{anotherTableData.shipmentDetail.awbNo} </td>
                                            </tr>






                                            <tr>
                                                <td className='fw-bold awbgrid ' > {FindTranslatedKey(anotherTableData.shipmentDetail.hBookingDate)}  </td>
                                                <td >  {anotherTableData.shipmentDetail.bookingDate} </td>

                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hWeight)}  </td>
                                                <td colspan='3'>  {anotherTableData.shipmentDetail.weight} </td>
                                            </tr>






                                            <tr>
                                                <td className='fw-bold awbgrid'> {FindTranslatedKey(anotherTableData.shipmentDetail.hVolWeight)}  </td>
                                                <td>  {anotherTableData.shipmentDetail.volWeight} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hValue)}  </td>
                                                <td>  {anotherTableData.shipmentDetail.totalValue} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hpcs)}   </td>
                                                <td >  {anotherTableData.shipmentDetail.quantity}</td>
                                            </tr>






                                            <tr>

                                                <td  className='fw-bold awbgrid' >
                                                    {FindTranslatedKey(anotherTableData.shipmentDetail.hConsignor)}  </td>
                                                <td >
                                                    <span className='text-center fw-bolder'>
                                                        {anotherTableData.shipmentDetail.consignor}</span> <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consignorAddress1} ,
                                                    {anotherTableData.shipmentDetail.consignorAddress2} ,
                                                    {anotherTableData.shipmentDetail.consignorAddress3}  <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consignorCountry} ,
                                                    {anotherTableData.shipmentDetail.consignorState} ,
                                                    {anotherTableData.shipmentDetail.consignorCity} ,
                                                    {anotherTableData.shipmentDetail.consignorZip} <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consignorPhoneNo}

                                                </td>

                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hConsignee)}  </td>
                                                <td colspan='3'>
                                                    <span className='text-center fw-bolder'>
                                                        {anotherTableData.shipmentDetail.consignee}
                                                    </span>  <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consigneeAddress1} ,
                                                    {anotherTableData.shipmentDetail.consigneeAddress2}
                                                    , {anotherTableData.shipmentDetail.consigneeAddress3}  <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consigneeCountry} ,
                                                    {anotherTableData.shipmentDetail.consigneeState} ,
                                                    {anotherTableData.shipmentDetail.consigneeCity} ,
                                                    {anotherTableData.shipmentDetail.consigneeZip}   <br />
                                                    <span className='fw-bold'></span>
                                                    {anotherTableData.shipmentDetail.consigneePhoneNo}
                                                </td>

                                            </tr>








                                            <tr>
                                                <td className='fw-bold awbgrid'> {FindTranslatedKey(anotherTableData.shipmentDetail.hConsigneeCity)}  </td>
                                                <td >  {anotherTableData.shipmentDetail.consigneeCity} </td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hPacketStatus)}  </td>
                                                <td colspan='3'> {anotherTableData.shipmentDetail.packetStatus}</td>
                                            </tr>









                                            <tr>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hPacketType)}  </td>
                                                <td >  {anotherTableData.shipmentDetail.packetType} </td>
                                                <td className='fw-bold awbgrid' >{FindTranslatedKey(anotherTableData.shipmentDetail.hPaymentType)}</td>
                                                <td colspan='3'>{anotherTableData.shipmentDetail.paymentType}</td>
                                            </tr>











                                            <tr>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hForwordingParty)}   </td>

                                                <td >  {anotherTableData.shipmentDetail.forwordingParty}</td>
                                                <td className='fw-bold awbgrid' > {FindTranslatedKey(anotherTableData.shipmentDetail.hForwordingNo)}  </td>
                                                <td colspan='3'> {anotherTableData.shipmentDetail.forwordingNo} </td>
                                            </tr>









                                            <tr>
                                              
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }



            {anotherTableData?.trackingDetails?.length > 0 &&
                <div className='main-card card border-0 mb-0' style={{ borderTop: "2px solid #f18282" }}>
                    <h5 className='m-1 p-2' >{FindTranslatedKey('Tracking History')} <FiMapPin className='text-danger' /></h5>
                    {/* Filter and Advance Filter Icon and paging*/}
                    <div className='card-header mb-1'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-md-4'>
                                <h6 className='m-0 d-flex gap-2'>
                                    <span>{`${anotherTableData?.trackingDetails?.length > 0 ? FindTranslatedKey('Total Records') + anotherTableData?.trackingDetails?.length : FindTranslatedKey('No Record Found') }`}</span>

                                </h6>
                            </div>
                            <div className='card-body'>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mb-0">
                                        <thead>
                                            <tr className='light-bg'>
                                                <th>{FindTranslatedKey('Status Date')}</th>
                                                <th>{FindTranslatedKey('POD Location')}</th>
                                                <th>{FindTranslatedKey('Status Detail')}</th>
                                                <th>{FindTranslatedKey('Customer Ref No.')}</th>
                                                <th>{FindTranslatedKey('Created Date')}</th>
                                              

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {anotherTableData?.trackingDetails?.map((item, index) =>
                                                <tr>
                                                    <td >{item.statusDate}</td>
                                                    <td >{item.podLocation}</td>
                                                    <td >{item.statusDetail}</td>
                                                    <td >{item.customerRefNo}</td>
                                                    <td >{item.createdDate}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }


        </>
    )
}
export default AwbQuery;